<template>
  <div
    v-show="shown"
    class="tooltip-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    shown: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tooltip-wrapper {
    position: absolute;
    top: calc(100% + 2px);
    left: 50%;
    transform: translate(-50%);
    background: $neutral-medium;
    color: $neutral-light-absolute;
    font-weight: 600;
    font-size: 0.8rem;
    white-space: nowrap;
    padding: 2px 5px;
    border-radius: 6px;

    &::before {
      content: '';
      position: absolute;
      left: calc(50% - 5px);
      top: -4px;
      width: 10px;
      height: 10px;
      border-radius: 4px;
      transform: rotate(45deg);
      background: $neutral-medium;
    }
  }
</style>
